import React, { useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { submitContactMessage } from '../../utils/firestore';
import { useForm } from 'react-hook-form';
import HeroSection from '../../components/common/HeroSection';
import SEO from '../../components/seo/SEO';


const Contact = () => {
  const [submitting, setSubmitting] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    setSubmitting(true);
    try {
      await submitContactMessage(data);
      toast.success('Mesaj başarıyla gönderildi!');
      reset();
    } catch (error) {
      console.error('Error submitting contact form:', error);
      toast.error('Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full">
      <SEO 
        title="Diyetisyen Nihal Kamış - İletişim | Diyetisyen ile Görüşme Planlayın"
        description="Diyetisyen Nihal Kamış ile iletişime geçin. Kişiselleştirilmiş diyet programları ve beslenme danışmanlığı için görüşmeniz nasıl planlanır? İletişim bilgileri ve sosyal medya hesapları."
        url="https://www.dytnihalkamis.com/contact"
        keywords="diyetisyen iletişim, diyetisyen mail, diyetisyen instagram, görüşmede planla, diyetisyen sosyal medya"
      />
      
      {/* Page Header */}
      <HeroSection title="İletişime Geçin" subtitle="Kişiselleştirilmiş danışmanlık için benimle iletişime geçin" />

      <div className="section-padding bg-white">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-nihal-dark mb-6">Mesaj Gönder</h2>
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-nihal-dark font-medium mb-2">
                    İsim Soyisim
                  </label>
                  <input
                    type="text"
                    id="name"
                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nihal-primary ${
                      errors.name ? 'border-red-500' : 'border-gray-300'
                    }`}
                    {...register('name', { required: 'İsim soyisim zorunludur.' })}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
                  )}
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-nihal-dark font-medium mb-2">
                    Mail Adresi
                  </label>
                  <input
                    type="email"
                    id="email"
                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nihal-primary ${
                      errors.email ? 'border-red-500' : 'border-gray-300'
                    }`}
                    {...register('email', { 
                      required: 'Mail zorunludur.',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Geçersiz mail adresi'
                      }
                    })}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
                  )}
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-nihal-dark font-medium mb-2">
                    Mesaj
                  </label>
                  <textarea
                    id="message"
                    rows="5"
                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nihal-primary ${
                      errors.message ? 'border-red-500' : 'border-gray-300'
                    }`}
                    {...register('message', { required: 'Mesaj zorunludur.' })}
                  ></textarea>
                  {errors.message && (
                    <p className="text-red-500 text-sm mt-1">{errors.message.message}</p>
                  )}
                </div>
                
                <button
                  type="submit"
                  disabled={submitting}
                  className="btn btn-primary w-full py-4 text-lg"
                >
                  {submitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                </button>
              </form>
            </motion.div>
            
            {/* Contact Information */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-nihal-dark mb-6">İletişim Bilgileri</h2>
              
              <div className="space-y-6 mb-10">
               
                
                
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-nihal-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-nihal-dark mb-1">Mail Adresi</h3>
                    <p className="text-gray-600">dytnihalkamis@gmail.com</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-nihal-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg
  xmlns="http://www.w3.org/2000/svg"
  fill="white"
  viewBox="0 0 24 24"
  className="w-6 h-6 text-dark-500"
>
  <path d="M7.75 2h8.5A5.76 5.76 0 0122 7.75v8.5A5.76 5.76 0 0116.25 22h-8.5A5.76 5.76 0 012 16.25v-8.5A5.76 5.76 0 017.75 2zm0 1.5A4.26 4.26 0 003.5 7.75v8.5A4.26 4.26 0 007.75 20.5h8.5a4.26 4.26 0 004.25-4.25v-8.5A4.26 4.26 0 0016.25 3.5h-8.5zm8.75 2.25a.75.75 0 110 1.5.75.75 0 010-1.5zm-4.25 1.75a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"/>
</svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-nihal-dark mb-1">Instagram</h3>
                    <p className="text-gray-600"><a href="https://www.instagram.com/dyt.nihalkamis/" target="_blank" rel="noopener noreferrer">
  @dyt.nihalkamis
</a></p>
                  </div>
                </div>
              </div>
              
              {/* Google Maps Embed 
              <div className="mb-10">
                <h3 className="text-xl font-bold text-nihal-dark mb-4">Find Us</h3>
                <div className="bg-gray-200 border-2 border-dashed rounded-xl w-full h-64 flex items-center justify-center text-gray-500">
                  Google Maps Embed
                </div>
              </div>
              */}
              {/* Social Media */}
              <div>
                <h3 className="text-xl font-bold text-nihal-dark mb-4">Takip Edin !</h3>
                <div className="flex space-x-4">
                  
                  <a 
                    href="https://www.instagram.com/dyt.nihalkamis/" 
                    className="w-10 h-10 bg-nihal-primary rounded-full flex items-center justify-center text-white hover:bg-opacity-90 transition-colors"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  
                  <a 
                    href="https://www.linkedin.com/in/nihal-nur-kam%C4%B1%C5%9F-b28210334/" 
                    className="w-10 h-10 bg-nihal-primary rounded-full flex items-center justify-center text-white hover:bg-opacity-90 transition-colors"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;